'use strict';

/* global $ */

import ValidateJs from './../../../vendor/jquery.validate';

import { ITGWebservice } from './../../../services/ITGWebservice';
import { cookieManager } from './../../../services/CookieManager';
import { goToNextStep, goToPrevStep, gtm_virtualpage_track, jsonifyForm, zipcodeRestrict } from './../_form_functions.js';
import { AnalyticsUserIds } from './../../analytics_user_ids';
import './../_validateRules';

export default registration => {
    console.log('registration', registration);
    let analyticsUserIds = new AnalyticsUserIds();

    let url_call = $(registration).data('url');
    let event_data = $(registration).data('event');

    let popinFormContent__title = $('.js-popinFormContent-title').html();
    let popinFormContent__description = $('.js-popinFormContent-description').html();

    let form_1 = $('#formStep_1');
    let form_2 = $('#formStep_2');
    let form_captcha = $('#formStep_captcha');

    let trainingID = url_call.split('?id=')[1];
    let trainingType = event_data.type;

    // Hide zipcode if formation and remove the step 2 if not formation
    if (trainingType === 'formation') {
        $('.jqInputZipCode-stepOne').remove();
    } else {
        $('#formStep_2').remove();
    }

    let form_2_data_send = false;


    /* COOKIES HANDLER : PRE-FILL & UPDATE
    -------------------------------------------------------------------------- */
    // au load renseigner [name="referring_website"] [name="arrival_url"]
    if (cookieManager.getCookieValue(cookieManager.site_referrer)) {
        $('[name="referring_website"]').val(cookieManager.getCookieValue(cookieManager.site_referrer));
    }
    if (cookieManager.getCookieValue(cookieManager.site_arrival)) {
        $('[name="arrival_url"]').val(cookieManager.getCookieValue(cookieManager.site_arrival));
    }

    // préremplir les champs si ils sont présents dans le cookie
    $('[name="lastname"]').val(cookieManager.getCookieValue(cookieManager.user_lastname));
    $('[name="firstname"]').val(cookieManager.getCookieValue(cookieManager.user_firstname));
    $('[name="birth_date"]').val(cookieManager.getCookieValue(cookieManager.user_birthdate));
    $('[name="phone"]').val(cookieManager.getCookieValue(cookieManager.user_phone));
    $('[name="zipcode"]').val(cookieManager.getCookieValue(cookieManager.user_zipcode));
    $('[name="email"]').val(cookieManager.getCookieValue(cookieManager.user_email));

    let updateCookie = () => {
        cookieManager.store({
            [cookieManager.user_lastvisit]: 'Inscription',
            [cookieManager.user_lastname]: $('[name="lastname"]').val(),
            [cookieManager.user_firstname]: $('[name="firstname"]').val(),
            [cookieManager.user_birthdate]: $('[name="birth_date"]').val(),
            [cookieManager.user_phone]: $('[name="phone"]').val(),
            [cookieManager.user_zipcode]: $('[name="zipcode"]').val(),
            [cookieManager.user_email]: $('[name="email"]').val()
        });
    };

    let errorMsg = (data) => {
        var code = data.status;
        if (data.error) {
            code = data.error.httpcode;
        }

        if (code === 304) {
            $('.js-popinFormContent-title').removeClass('popinFormContent__success').addClass('popinFormContent__fail');
            $('.js-popinFormContent-title').html('Votre demande n\'a pu aboutir');
            $('.js-btn-step2').prop('disabled', true);

            $('.js-popinFormContent-description').addClass('errorBox');
            $('.js-popinFormContent-description').html('Vous êtes déjà inscrit à cette formation.');
            $('.js-btn-step2').prop('disabled', true);
        } else if (code === 404) {
            $('.js-popinFormContent-title').removeClass('popinFormContent__success').addClass('popinFormContent__fail');
            $('.js-popinFormContent-title').html('Votre demande n\'a pu aboutir');
            $('.js-btn-step2').prop('disabled', true);

            $('.js-popinFormContent-description').addClass('errorBox');
            $('.js-popinFormContent-description').html('Ce formulaire est actuellement indisponible. Veuillez réessayer ultérieurement ou nous contacter directement par téléphone au 09 74 77 00 90 (prix d’un appel local) ou par mail sur <a href="mailto:conseil@itg.fr">conseil@itg.fr</a>.');
            $('.js-btn-step2').prop('disabled', true);
        } else if (code === 422) {
            $('.js-popinFormContent-title').removeClass('popinFormContent__success').addClass('popinFormContent__fail');
            $('.js-popinFormContent-title').html('Votre demande n\'a pu aboutir');
            $('.js-btn-step2').prop('disabled', true);

            $('.js-popinFormContent-description').addClass('errorBox');
            $('.js-popinFormContent-description').html('Suite à un problème technique, nous n’avons pas pu enregistrer votre demande. Veuillez réessayer ultérieurement ou nous contacter directement par téléphone au 09 74 77 00 90 (prix d’un appel local) ou par mail sur <a href="mailto:conseil@itg.fr">conseil@itg.fr</a>.');
            $('.js-btn-step2').prop('disabled', true);
        } else if (code === 423) {
            $('.js-popinFormContent-title').removeClass('popinFormContent__success').addClass('popinFormContent__fail');
            $('.js-popinFormContent-title').html('Votre demande n\'a pu aboutir');
            $('.js-btn-step2').prop('disabled', true);

            $('.js-popinFormContent-description').addClass('errorBox');
            $('.js-popinFormContent-description').html('Il ne reste plus de places disponibles dans cette formation. Veuillez sélectionner une autre date ou nous contacter par téléphone au 09 74 77 00 90 (prix d’un appel local) ou par mail sur <a href="mailto:conseil@itg.fr">conseil@itg.fr</a>.');
            $('.js-btn-step2').prop('disabled', true);
        } else if (code === 401) {
            $('.js-popinFormContent-description').addClass('errorBox');
            $('.js-popinFormContent-description').html('Ce formulaire est actuellement indisponible.<br>Veuillez réessayer ultérieurement ou nous contacter directement par téléphone au 09 74 77 00 90 (prix d’un appel local) ou par mail sur <a href="mailto:conseil@itg.fr">conseil@itg.fr</a>.');
            $('.js-btn-step2').prop('disabled', true);
        } else if (code >= 400 && code < 500) {
            $('.js-popinFormContent-description').addClass('errorBox');
            $('.js-popinFormContent-description').html('Suite à un problème technique, nous n’avons pas pu enregistrer votre demande. Veuillez réessayer ultérieurement ou nous contacter directement par téléphone au 09 74 77 00 90 (prix d’un appel local) ou par mail sur <a href="mailto:conseil@itg.fr">conseil@itg.fr</a>.');
            $('.js-btn-step2').prop('disabled', true);
        } else if (code >= 500) {
            $('.js-popinFormContent-description').addClass('errorBox');
            $('.js-popinFormContent-description').html('Ce formulaire est actuellement indisponible. Veuillez réessayer ultérieurement ou nous contacter par téléphone au 09 74 77 00 90 (prix d\'un appel local) ou par mail <a href="mailto:conseil@itg.fr">conseil@itg.fr</a>.');
            $('.js-btn-step2').prop('disabled', true);
        } else if (code >= 300) {
            $('.js-popinFormContent-description').addClass('errorBox');
            $('.js-popinFormContent-description').html('Ce formulaire est actuellement indisponible. Veuillez réessayer ultérieurement ou nous contacter directement par téléphone au 09 74 77 00 90 (prix d’un appel local) ou par mail sur <a href="mailto:conseil@itg.fr">conseil@itg.fr</a>.');
            $('.js-btn-step2').prop('disabled', true);
        }
    };


    /* CHANGE TITLE IF trainingType is marketing
    -------------------------------------------------------------------------- */
    if (trainingType === 'marketing' && $('.js-popinFormBox__title').length) {
        $('.js-popinFormBox__title').text('Inscription à une journée marketing');
    }


    /* ZIPCODE
    -------------------------------------------------------------------------- */
    zipcodeRestrict();


    /* GTM
    -------------------------------------------------------------------------- */
    gtm_virtualpage_track($('#formStep_1'));


    /* CAPTCHA
    -------------------------------------------------------------------------- */
    let initCaptcha = () => {
    	if ($('#formStep_captcha').find('.g-recaptcha-response').length && $('#formStep_captcha').find('.g-recaptcha-response').val() === '') {
    		if (typeof grecaptcha === 'object') {
                grecaptcha.execute();
                console.log('captcha EXECUTE');
            }

            setTimeout(function () { initCaptcha() }, 1000);
        }
    };
    $(document).ready(function () {
    	setTimeout(function () { initCaptcha() }, 1000);
    });


    /* FORM VALIDATION & DATA & AJAX SUBMIT
    -------------------------------------------------------------------------- */
    // validation
    let formStep_1__validate = () => {
        form_1.validate({
            errorLabelContainer: '.js-errorPopinList',
            errorElement: 'li',
            errorClass: 'inputError',
            highlight: function (element) {
                $(element).closest('.formEntry').addClass('formError');
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).closest('.formEntry').removeClass('formError');
            },
            rules: {
                email: {
                    required: true,
                    strictEmail: true
                },
                phone: {
                    minlength: 10,
                    digits: true
                }
            },
            messages: {
                firstname: 'Veuillez saisir votre prénom',
                lastname: 'Veuillez saisir votre nom',
                phone: 'Veuillez saisir votre numéro de téléphone',
                email: {
                    required: 'Veuillez saisir votre adresse mail',
                    email: 'Veuillez saisir une adresse mail valide',
                    strictEmail: 'Veuillez saisir une adresse mail valide'
                }
            }
        });
    };

    let formStep_2__validate = () => {
        form_2.validate({
            errorLabelContainer: '.js-errorPopinList',
            errorElement: 'li',
            errorClass: 'inputError',
            highlight: function (element) {
                $(element).closest('.formEntry').addClass('formError');
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).closest('.formEntry').removeClass('formError');
            },
            rules: {
                zipcode: {
                    required: true,
                    digits: true,
                    number: true,
                    minlength: 5,
                    maxlength: 5
                },
                birth_date: {
                    dateFormat: true
                }
            },
            messages: {
                zipcode: {
                    required: 'Veuillez renseigner votre code postal',
                    digits: 'Veuillez renseigner un code postal à 5 chiffres',
                    number: 'Veuillez renseigner un code postal à 5 chiffres',
                    minlength: 'Veuillez renseigner un code postal à 5 chiffres',
                    maxlength: 'Veuillez renseigner un code postal à 5 chiffres'
                },
                birth_date: 'Veuillez indiquer une date valide'
            }
        });
    };

    // data
    let collectData_formStep_1 = () => {
        // Form Json for WS
        let formJson = {};
        formJson.registration = jsonifyForm(form_1.serializeArray().concat(form_captcha.serializeArray()));

        let comment = {};
        comment.birth_date = $('[name="birth_date"]').val();
        comment.project = $('[name="project"]').val();
        formJson.registration.comment = JSON.stringify(comment);

        // DEBUG: Display the key/value pairs
        console.log('DATA WS step 1', formJson);

        return formJson;
    };

    let collectData_formStep_2 = () => {
        // Form Json for WS
        let formJson = {};
        formJson.contact = jsonifyForm(form_1.serializeArray().concat(form_captcha.serializeArray()));
        formJson.contact.contact_reason_id = 12;
        formJson.contact.zipcode = $('[name="zipcode"]').val();

        let comment = {};
        comment.birth_date = $('[name="birth_date"]').val();
        comment.project = $('[name="project"]').val();
        formJson.contact.comment = JSON.stringify(comment);

        // DEBUG: Display the key/value pairs
        console.log('DATA WS step 2', formJson);

        return formJson;
    };

    // ajax
    let sendData_formStep_1 = (func) => {
        var async = !(typeof grecaptcha == 'object');
        // var async = true;

        if (trainingType === 'formation') {
            let params = collectData_formStep_1().registration;
            params.formation_id = trainingID;
            params.formation_name = event_data.name;
            params.formation_date = event_data.date;
            params.formation_place = event_data.place;

            var res = ITGWebservice
                .sendRequest(ITGWebservice.formation_url, null, params, 'json', async)
                .done((data, textStatus, jqXHR) => {
                  console.log("jqXHR.status", jqXHR.status)
                    if (async) {
                        if (jqXHR.status === 200) {
                            if (typeof func === 'function') func();
                        } else {
                            errorMsg(jqXHR);
                        }
                    }
                });
        } else {
            $('.js-popinFormContent-title').addClass('popinFormContent__success').removeClass('popinFormContent__fail');
            $('.js-popinFormContent-title').html(popinFormContent__title);
            $('.js-popinFormContent-description').removeClass('errorBox');
            $('.js-popinFormContent-description').html(popinFormContent__description);
            $('.js-btn-step2').prop('disabled', false);

            // Pour l'atelier, marketing on attends pas le résultat de la requête
            if (['atelier', 'marketing'].includes(trainingType)) {
                if (typeof func === 'function') {
                    func();
                }
            }

            var resApiUrl = ITGWebservice
                .sendRequest(ITGWebservice.api_url, ITGWebservice.endpoint_registration(trainingID), collectData_formStep_1(), 'json', async)
                .done((data, textStatus, jqXHR) => {
                    console.log("jqXHR.status", jqXHR.status)
                    console.log("typeof func", typeof func)
                    if (async) {
                        if (jqXHR.status === 200) {
                            let userIdObject = data.registration.trainee;
                            if (userIdObject.google_analytics_id_created) {
                                analyticsUserIds.setUserId(userIdObject.google_analytics_id, 'inscription-atelier');
                            } else {
                                analyticsUserIds.setUserId(userIdObject.google_analytics_id);
                            }

                            if (typeof func === 'function') {
                                func();
                            }
                        } else {
                            errorMsg(jqXHR);
                        }
                    }
                });


            var resRequestSimulateur = ITGWebservice.sendRequest(ITGWebservice.api_request_simulateur_url, ITGWebservice.endpoint_registration(trainingID), collectData_formStep_1(), 'json', async)
                .done((data, textStatus, jqXHR) => {
                    if (async) {
                        if (jqXHR.status === 200 && typeof data.registration !== 'undefined') {
                            let userIdObject = data.registration.trainee;
                            if (userIdObject.google_analytics_id_created) {
                                analyticsUserIds.setUserId(userIdObject.google_analytics_id, 'inscription-atelier');
                            } else {
                                analyticsUserIds.setUserId(userIdObject.google_analytics_id);
                            }
                            if (typeof func === 'function') func();
                        } else {
                            errorMsg(jqXHR);
                        }
                    }
                });
        }

        dataLayer.push({
            'event': 'form_submit',
            'goal_type': 'Formulaire - BotB',
            'form_name': 'BtoB',
            'form_type': 'BtoB'
        });

        return true;
    };

    let sendData_formStep_2 = (func) => {
        var async = !(typeof grecaptcha === 'object');

        if (trainingType === 'formation') {
            let params = collectData_formStep_2().contact;
            params.formation_id = trainingID;
            params.formation_name = event_data.name;
            params.formation_date = event_data.date;
            params.formation_place = event_data.place;

            var res = ITGWebservice.sendRequest(ITGWebservice.formation_url, null, params, 'json')
                .done((data, textStatus, jqXHR) => {
                    if (jqXHR.status === 200) {
                        if (typeof func === 'function') func();
                    } else {
                        errorMsg(jqXHR);
                    }
                }, (data, textStatus, jqXHR) => {
                    errorMsg(jqXHR);
                });

            if (!async) {
                if (typeof res.responseJSON.error === 'string') {
                    alert(res.responseJSON.error);
                    return false;
                } else {
                    if (typeof func === 'function') func();
                }
            }
        } else {
            var res = ITGWebservice.sendRequest(ITGWebservice.api_request_simulateur_url, ITGWebservice.endpoint_contact, collectData_formStep_2(), 'json')
                .done((data, textStatus, jqXHR) => {
                    if (jqXHR.status === 200) {
                        if (typeof func === 'function') func();
                    } else {
                        errorMsg(jqXHR);
                    }
                }, (data, textStatus, jqXHR) => {
                    errorMsg(jqXHR);
                }
                );

            if (!async) {
                if (typeof res.responseJSON !== 'undefined' && typeof res.responseJSON.error === 'string') {
                    alert(res.responseJSON.error);
                    return false;
                }
            }
        }
    };


    /* EVENT HANDLERS
    -------------------------------------------------------------------------- */
    form_1.on('submit', (e) => {
        e.preventDefault();

        formStep_1__validate();

        if (form_1.valid()) {
            updateCookie();
            sendData_formStep_1(function () {
                console.log("Go to the next target")
                goToNextStep($('.next', e.currentTarget));
            });
        }
    });

    form_2.on('submit', (e) => {
        e.preventDefault();

        formStep_2__validate();
        if (form_2.valid() && !form_2_data_send) {
            form_2_data_send = true;
            sendData_formStep_2(function () {
                console.log("Go to the next target")
                goToNextStep($('.next', e.currentTarget));
            });
            updateCookie();
        }
    });

    // PREV btn
    $('.previous').on('click', (e) => {
        goToPrevStep($(e.currentTarget));
    });

    // POPIN CLOSE btn
    $('.fancybox-close-small').on('click', (e) => {
        if ((!form_2_data_send) && ($('#formStep_1').css('display') === 'none')) {
            updateCookie();
        }
    });

    $('.popinFormBox-close-inside').on('click', (e) => {
        e.preventDefault();
        $('.fancybox-close-small').trigger('click');
    });

    window.addEventListener('keypress', function (evt) {
	    if (evt.target.id == 'firstname' || evt.target.id == 'lastname') {
	        evt = (evt) || window.event;
	        var charCode = (evt.which) ? evt.which : evt.keyCode;
	        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
	            return true;
	        } else {
	            evt.preventDefault();
	        }
	    } else if (evt.target.id == 'phone') {
	    	evt = (evt) || window.event;
	        var charCode = (evt.which) ? evt.which : evt.keyCode;
	        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
	            evt.preventDefault();
            } else if (evt.target.value.length >= 10) {
	            evt.preventDefault();
	        } else {
	            return true;
	        }
        }
    });
};



// WEBPACK FOOTER //
// ./front/js/modules/forms/popins/registration.js